
export function getHost() {
  return window.location.origin;
}

export function withHost(path) {
  return `${getHost()}${path}`;
}

export function getParam(sParam, url) {
  let sPageURL = url ? url : window.location.search.substring(1);
  let sURLVariables = sPageURL.split('&');
  for (let i = 0; i < sURLVariables.length; i++) {
    let sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] == sParam) {
        return sParameterName[1];
    }
  }
}

export function getQueryParams(url) {
  if(!url || url.indexOf('?') == -1)
    return undefined;
  let queries = url ? url.split('?')[1] : window.location.search;
  queries = queries.replace(/(^\?)/,'').split("&").map(function(n) {return n = n.split("="),this[n[0]] = decodeURIComponent(n[1]),this}.bind({}))[0];
  return queries;
}

export function getPathWithoutQuery(url) {
  let pathOnly = url ? url.split('?')[0] : window.location.search;
  return pathOnly;
}

export function paramsToString(obj) {
  let parts = [];
  for (let i in obj) {
    if (obj.hasOwnProperty(i) && !_.isNil(obj[i])) {
        parts.push(encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]));
    }
  }
  return parts.join("&");
}

export function path(path, params) {
  return mergeUrl(path, params);
}

export function mergeUrl(url, params, urlMap) {
  if(!url) {
    console.error("URL is not defined for action: ", params);
  }
  if(!params)
    return url;
  params = _.merge({}, params);
  if(urlMap) {
    _.keys(urlMap).forEach((k) => {
      params[urlMap[k]] = params[k];
      delete params[k];
    });
  }
  if(url.indexOf(":") !== -1) {
    _.forEach(url.match(/:([0-9_a-z]+)/gi), (match)=>{
      let key = match.replace(":", "");
      if(!params[key]) return;
      url = url.replace(match, params[key]);
      params = _.omit(params, key);
    });
  }
  if(_.keys(params).length > 0) {
    url = url + "?" + paramsToString(params);
  }
  return url;
}

export function pathBefore(path, segment) {
  if(!path) return undefined;
  if(!segment) return path;
  return path.split(segment)[0];
}
